// Public API for render
export {RootRenderer, Renderer, RenderComponentType} from './render/api';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
